export default __webpack_public_path__ + "static/media/icon-Beneficio01.ce31f5ff.svg";